/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<ellipse
				opacity="0.12"
				cx="12"
				cy="12"
				rx="10"
				ry="9"
				fill="currentColor"
			/>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M17 4C19.9634 5.46093 22 8.49453 22 12C22 15.5055 19.9634 18.5391 17 20M7 4C4.03656 5.46093 2 8.49453 2 12C2 15.5055 4.03656 18.5391 7 20M16.0005 8C17.2147 8.91223 18 10.3644 18 12C18 13.6356 17.2147 15.0878 16.0005 16M7.99951 8C6.78534 8.91223 6 10.3644 6 12C6 13.6356 6.78534 15.0878 7.99951 16M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
